import { CompNodes } from '@wix/thunderbolt-catharsis'
import { compLayouts } from '../responsiveLayout/compLayoutsCompNode'
import { pinnedLayer } from '../responsiveLayout/pinnedLayerCompNode'
import { responsiveLayout } from '../responsiveLayout/responsiveLayoutCompNode'
import { layoutVariants } from '../responsiveLayout/layoutVariantsCompNode'
import { componentCss } from '../css/componentCssCompNode'
import { CssCompNodes } from '../types'
import { variables } from '../variables/variablesCompNode'
import { variablesVariants } from '../variables/variablesVariantsCompNode'

export const componentNodes: CompNodes<CssCompNodes> = {
	compLayouts,
	responsiveLayout,
	pinnedLayer,
	layoutVariants,
	variables,
	variablesVariants,
	componentCss,
}
